class SectionVideoSteps implements ng.IComponentController {
    reverse: boolean;
    ltTitle: string;
    description: string;
    steps: anm.VideoStep[];
    buttons: anm.LandingButtonData[];
}

angular.module('animatronApp.sectionVideoSteps', []).component('sectionVideoSteps', {
    bindings: {
        reverse: '<',
        ltTitle: '<',
        description: '<',
        steps: '<',
        buttons: '<'
    },
    controller: SectionVideoSteps,
    templateUrl: require('landing-template/components/sections/section-video-steps.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/landing-template/components/sections/SectionVideoSteps.ts